import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Authorize from '../../components/AuthComponent/Authorize';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import ColorPickerField from '../../components/Fields/ColorPickerField';
import DateControl from '../../components/Fields/DateControl';
import Field from '../../components/Fields/Field';
import FieldLabel from '../../components/Fields/FieldLabel';
import Form from '../../components/Fields/Form';
import NumberField from '../../components/Fields/NumberField';
import TextboxField from '../../components/Fields/TextboxField';
import { FormConfig } from '../../components/Fields/Types';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import { ApplicationFunctions } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import ColorModel from '../../models/ColorModel';
import DataService from '../../services/data.service';
import { Result } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';

const ColorView: React.FC = () => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<ColorModel>();

    let id = useParams().id;

    useEffect(() => {
        getFormData()
    }, [id]);

    function getFormData() {
        if (id !== undefined) {
            DataService.getById<ColorModel>('api/v1/Colors/', id)
                .then(response => setFormData(response))
                .catch(e => {
                    if (e.response?.data?.status === 401)
                        setIsAuthorized(false);
                    else
                        handleException(e);
                });
        }
    }

    function submit() {
        if (formData) {
            DataService
                .update<ColorModel>(`api/v1/Colors`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        setFormData(response.data);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', labelSize: 2, validationRules: [{ type: 'isRequired' }, {type: 'isMaxLength', maxLength: 100}] },
            { name: 'abbreviation', label: 'Abbrevistion', labelSize: 2, validationRules: [{ type: 'isRequired' }, { type: 'isMaxLength', maxLength: 10 }] },
            { name: 'colorFamily', label: 'Color family', labelSize: 2, validationRules: [{ type: 'isMaxLength', maxLength: 150 }] },
            { name: 'colorCode', label: 'Color code', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'textColorCode', label: 'Text color code', labelSize: 2},
            { name: 'sortOrder', label: 'Sort order', labelSize: 2 },
            { name: 'beginDate', label: 'Active from', validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Active until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getLabelProps, getControlProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    if (!isAuthorized)
        return (<Unauthorized />);

    return (
        <div className='main-content'>
            <Form title='Color' footer={(
                <Row>
                    <Col md='12'>
                        <ButtonBar offset={2}>
                            <Authorize applicationFunction={ApplicationFunctions.EditColor}>
                                <SaveButton  {...getSubmitButtonProps()} />
                            </Authorize>
                        </ButtonBar>
                    </Col>
                </Row>
            )}>
                <Container fluid>
                    <Row>
                        <Col md='10'>
                            <TextboxField {...getFieldProps('name')} />
                            <TextboxField {...getFieldProps('abbreviation')} />
                            <TextboxField {...getFieldProps('colorFamily')} />
                            <ColorPickerField {...getFieldProps('colorCode')} />
                            <ColorPickerField {...getFieldProps('textColorCode')} />
                            <NumberField {...getFieldProps('sortOrder')} />
                            <Field {...getLabelProps('beginDate')}>
                                <DateControl {...getControlProps('beginDate')} />
                                <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                                <DateControl {...getControlProps('endDate')} />
                            </Field>
                        </Col>
                    </Row>
                </Container>
            </Form>
        </div>
    );
}
export default ColorView;